import { setDeclineT, SET_DECLINE } from "../reducers/DeclineState"

export const SetDecline = ( data: setDeclineT['data'] ) => {
  return ( {
    type: SET_DECLINE,
    data: data
  } )
}
